export const initialOrganizationsFilters = () => ({
  search: "",
  city: "",
  legal_entity_inn: "",
  ids: "",
  legal_entity: "",
  member: "",
  parent_id: "",
});
